import { extend } from '@/lib/utils/extend';
import Toast from "vant/es/toast";
import "vant/es/toast/style/index.js";
var AbpUi = /** @class */ (function () {
    function AbpUi() {
    }
    AbpUi.block = function (elm) {
        Toast.loading({
            duration: 0,
            forbidClick: true
        });
    };
    AbpUi.unblock = function (elm) {
        Toast.clear();
    };
    AbpUi.setBusy = function (elm, optionsOrPromise) {
        var options = extend({
            duration: 0,
            forbidClick: true
        }, optionsOrPromise);
        Toast.loading(options);
    };
    AbpUi.clearBusy = function (elm) {
        Toast.clear();
    };
    return AbpUi;
}());
var abpUi = {
    ui: AbpUi
};
window.abp = extend(true, window.abp, abpUi);
